import {
    immoweltNewEstimationFormFieldsValidators,
    immoweltRegularExpressions,
} from '@aviv-estimation-funnel/portals-configurations/immowelt.config';

import { generateGermanStepsConfig, IGermanFrontConfiguration } from '../common/germanStepsConfig';

const PRIVACY_URL = `${process.env['NX_PORTAL_URL']}/immoweltag/datenschutz`;

const germanConfig = generateGermanStepsConfig(
    immoweltNewEstimationFormFieldsValidators,
    immoweltRegularExpressions,
);

export const immoweltFrontConfiguration: IGermanFrontConfiguration = {
    steps: {
        ...germanConfig,
        identity: {
            ...germanConfig.identity,
            termsAndConditions: {
                termsAndConditionsOfServiceUrl: {
                    de: `${process.env['NX_PORTAL_URL']}/immoweltag/agb/online_immobilienbewertung`,
                    en: `${process.env['NX_PORTAL_URL']}/immoweltag/agb/online_immobilienbewertung`,
                },
                privacyPolicyUrl: {
                    de: PRIVACY_URL,
                    en: PRIVACY_URL,
                },
                avivWebsiteUrl: {
                    de: 'https://www.aviv-group.com/companies',
                    fr: 'https://www.aviv-group.com/companies',
                },
            },
        },
    },
    footer: {
        copyright: 'AVIV Germany GmbH ©',
        links: {
            termsAndConditions: {
                de: `${process.env['NX_PORTAL_URL']}/immoweltag/agb`,
                en: `${process.env['NX_PORTAL_URL']}/immoweltag/agb`,
            },
            legalNotice: {
                de: `${process.env['NX_PORTAL_URL']}/immoweltag/impressum`,
                en: `${process.env['NX_PORTAL_URL']}/immoweltag/impressum`,
            },
            privacy: {
                de: PRIVACY_URL,
                en: PRIVACY_URL,
            },
        },
        openCookieBanner: () => {
            if (typeof window?.UC_UI?.showSecondLayer === 'function')
                window.UC_UI.showSecondLayer();
        },
    },
};
